export default [{
  path: '/data/banners',
  name: 'Banner',
  component: () => import('@/views/admin/banners/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Banner',
    breadcrumb: [{
        title: 'Home',
        url: '/'
      },
      {
        title: 'Data'
      },
      {
        title: 'Banner',
        active: true
      },
    ],
  }
}]
